import * as MP4BoxWithoutTypes from 'mp4box';

export const MP4Box = MP4BoxWithoutTypes as unknown as MP4BoxType;

interface MP4BoxFileType {
    onReady(fileInfo: Mp4BoxFileInfo): void;
    appendBuffer(arrayBuffer: ArrayBuffer): void;
    flush(): void;
}

interface MP4BoxType {
    createFile(): MP4BoxFileType;
}

type Mp4BoxFileTrack = {
    id: number;
    created: string;
    modified: string;
    movie_duration: number;
    layer: number;
    alternate_group: number;
    volume: number;
    track_width: number;
    track_height: number;
    timescale: number;
    duration: number;
    bitrate: number;
    codec: string;
    video: {
        width: number;
        height: number;
    };
    language: string;
    nb_samples: number;
    type: string;
};

export type Mp4BoxFileInfo = {
    duration: number;
    timescale: number;
    isFragmented: boolean;
    isProgressive: boolean;
    hasIOD: boolean;
    brands: string[];
    created: string;
    modified: string;
    tracks: Mp4BoxFileTrack[];
    mime: string;
};
